import { Outlet, useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import MuiDrawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
// import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";

import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import MenuIcon from "@mui/icons-material/Menu";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import NavbarNEW from "../../../Layout/NavbarNEW";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";
import { capitalizeWords } from "../../../utils/common/capitalize";

const user = JSON.parse(localStorage.getItem("user"));

const drawerWidth = 240;

// mainListItems format
// const mainListItems = [
//   {
//     id: 1,
//     label: "Profile",
//     link: "/user-dashboard/profile",
//     icon: <DashboardIcon />,
//   },
//   {
//     id: 2,
//     label: "Payments",
//     link: "/user-dashboard/payments",
//     icon: <PaymentIcon />,
//   },
//   {
//     id: 3,
//     label: "Trading",
//     link: "/user-dashboard/trading",
//     icon: <ShowChartIcon />,
//   },
//   {
//     id: 4,
//     label: "Referrals",
//     link: "/user-dashboard/referrals",
//     icon: <Diversity3Icon />,
//   },

//   {
//     id: 5,
//     label: "Support",
//     link: "/user-dashboard/support  ",
//     icon: <EmailIcon />,
//   },
// ];

// const AppBar = styled(MuiAppBar, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   zIndex: theme.zIndex.drawer + 1,
//   transition: theme.transitions.create(["width", "margin"], {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   ...(open && {
//     marginLeft: drawerWidth,
//     width: `calc(100% - ${drawerWidth}px)`,
//     transition: theme.transitions.create(["width", "margin"], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   }),
// }));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    }),
  },
}));

const mdTheme = createTheme();

export default function DashboardLayout({
  mainListItems,
  secondListItems = [],
}) {
  const {
    user: { userDetails },
  } = useSelector((store) => store.auth);

  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <ThemeProvider theme={mdTheme}>
      <NavbarNEW isAuth={!!user} userDetails={userDetails} />

      <Box sx={{ display: "flex" }}>
        <CssBaseline />

        <Drawer variant="permanent" open={open}>
          <Toolbar
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              px: [1],
            }}
          >
            {open && (
              <Typography
                variant="h6"
                component="div"
                sx={{
                  position: "absolute",
                  left: "50%",
                  transform: "translateX(-50%)",
                  fontSize: "0.875rem",
                  whiteSpace: "nowrap", // Prevents text wrapping
                  overflow: "hidden", // Hides overflowing text
                  textOverflow: "ellipsis", // Adds "..." for overflowing text
                  maxWidth: "150px", // Set a maximum width for the text container
                }}
              >
                {capitalizeWords(userDetails.username)}
              </Typography>
            )}
            <IconButton style={{ marginRight: "3 rem" }} onClick={toggleDrawer}>
              <MenuIcon />
            </IconButton>
          </Toolbar>
          <Divider />
          <List component="nav">
            {/* {mainListItems} */}
            {mainListItems.map((list) => {
              return (
                <ListItemButton onClick={() => navigate(list.link)}>
                  <ListItemIcon>{list.icon}</ListItemIcon>
                  <ListItemText
                    primary={
                      <span
                        style={{
                          display: "block",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {list.label}
                      </span>
                    }
                  />
                </ListItemButton>
              );
            })}

            <Divider sx={{ my: 1 }} />

            {secondListItems.map((list) => {
              return (
                <ListItemButton onClick={() => navigate(list.link)}>
                  <ListItemIcon>{list.icon}</ListItemIcon>
                  <ListItemText
                    primary={
                      <span
                        style={{
                          display: "block",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {list.label}
                      </span>
                    }
                  />
                </ListItemButton>
              );
            })}
          </List>
        </Drawer>

        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "light"
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
          }}
        >
          {/* <Toolbar /> */}
          <Outlet />
        </Box>
      </Box>
    </ThemeProvider>
  );
}
